export default __webpack_public_path__ + "media/onboarding/welcome_free_account_ideas-0100cec6.png";